export class ConveyanceSellerAssignedBillingRulesResultDto {
    communityName: string;
    hasBillingRuleAssigned: boolean;
}
